module.exports = __webpack_public_path__ + "img/image4.8f8aa6ec.jpg";